<template>
  <div class="OHowPeopleUseLifferyCouple  pl-4 pr-4 pb-4">
    <div>
      <img src="@/assets/landing-pages/forPeople/2023/decision-maker.png" alt="Liffery Tinder">
    </div>

    <div class="person">
      <div>
        <img src="../../../../assets/landing-pages/forPeople/2023/face-the-couple.svg" alt="Liffery couple"/>
      </div>

      <div class="description content">
        <h2>
          Decision Maker
          <!--          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyCouples.title') }}-->
        </h2>
        <p>
          Making decisions in a couple or group can be tricky: The Decision Maker lets everyone get their opinion heard
          and lets the group make a decision quickly.
          <!--          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyCouples.text') }}-->
        </p>
        <p>
          It's kind of like Tinder, but for products and things.
          <!--          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyCouples.text2') }}-->
        </p>
        <p>
          <router-link
            v-if="getIsAuthenticated"
            :to="{name: routeNames.ROUTE_DASHBOARD}"
          >
            <b-button type="is-primary" class="lfr-button">
              {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
            </b-button>
          </router-link>
          <b-button v-else class="is-primary" @click="loginPrompt">
            {{ $tc('page.whatIsLiffery.new2023.learnMore') }}
          </b-button>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.OHowPeopleUseLifferyCouple {
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;

  .person {
    display: flex;
    align-items: center;
    gap: 4rem;

    .description {
      width: 400px;
    }
  }

  @media screen and (max-width: $desktop) {
    .person {
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;
    }
  }

  @media screen and (max-width: 915px) {
    flex-direction: column-reverse;
    padding-top: 8rem;

    .person {
      flex-direction: column;
      align-items: center;
      gap: 2rem;

      .face {
        margin-right: 8rem;
      }

      .description {
        width: unset;
        text-align: center;
      }
    }
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component
export default class OHowPeopleUseLifferyCouples extends Vue {

  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaDecisionMaker
      }
    });
  }
}
</script>
